<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <!-- <div class="rdg_biv_t">财务数据分析师全国统一报名入口</div> -->
        <div class="user_reg">
            <div class="r_tit">{{currentStep===4?'资格审核':currentStep===5?'开通课程':'学员注册'}}</div>
            <div class="blank20"/>
            <div class="l-r-content">
                <Step1 v-show="currentStep===1" @changeStep="changeStep"/>
                <Step2 v-show="currentStep===2&&temToken!==''" :token="temToken" @changeStep="changeStep"/>
                <Step3 v-show="currentStep===3" @changeStep="changeStep"/>
                <Step4 v-show="currentStep===4" :level="level" @changeStep="changeStep"/>
                <Step5 v-show="currentStep===5" :level="level" @changeStep="changeStep"/>
                <!-- <RightContent type="register" :currentStep="Number(currentStep)"/> -->
            </div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import Step1 from './components/registerStep1'
import Step2 from './components/registerStep2'
import Step3 from './components/registerStep3'
import Step4 from './components/registerStep4'
import Step5 from './components/registerStep5'
// import RightContent from './components/rightContent';
export default {
    data() {
        return {
            temToken:'',
            currentStep:1,
        }
    },
    components:{
        // RightContent,
        Step1,
        Step2,
        Step3,
        Step4,
        Step5
    },
    created() {
    },
    methods: {
        changeStep(val){
            if(typeof val === 'object'){
                if(Object.hasOwnProperty.call(val,'temToken')){
                    this.temToken = val.temToken;
                }else{
                    this.level = val.level;
                }
                
                this.currentStep = Number(val.val);
            }else{
                this.currentStep = Number(val);
            }
            
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
